import { render, staticRenderFns } from "./ApprovalNoteDialog.vue?vue&type=template&id=4d6656ef&"
import script from "./ApprovalNoteDialog.vue?vue&type=script&lang=js&"
export * from "./ApprovalNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports